try {
  const BRAZE_API_KEY = import.meta.env.VITE_BRAZE_API_KEY;
  const BRAZE_ENDPOINT = import.meta.env.VITE_BRAZE_ENDPOINT;
  const PROD_ENVIRONMENT = import.meta.env.PROD === 'true';

  if (!BRAZE_API_KEY || !BRAZE_ENDPOINT) {
    console.error(
      '[Braze] Missing API key or endpoint in environment variables'
    );
    throw new Error('Missing Braze configuration');
  }

  const enableLogging = !PROD_ENVIRONMENT;

  const script = document.createElement('script');
  script.src = 'https://js.appboycdn.com/web-sdk/4.9/braze.min.js';
  script.async = true;

  script.onload = () => {
    if (!window.braze) {
      console.error('[Braze] SDK loaded but window.braze not found');
      return;
    }

    window.braze.initialize(BRAZE_API_KEY, {
      baseUrl: BRAZE_ENDPOINT,
      enableLogging: enableLogging,
      allowCrawlerActivity: false,
      doNotLoadFontAwesome: true
    });

    window.braze.openSession();
    //para eventos de signup
    window.dispatchEvent(new Event('braze:ready'));

    console.info('[Braze] Early initialization completed');
  };

  script.onerror = () => {
    console.error('[Braze] Failed to load SDK script');
  };

  document.head.appendChild(script);
} catch (error) {
  console.error('[Braze] Initialization error:', error);
}
